var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5625 18.3437H53.6562V16.4375C53.6562 13.284 51.091 10.7188 47.9375 10.7188H17.4375C14.284 10.7188 11.7188 13.284 11.7188 16.4375V46.9375C11.7188 50.091 14.284 52.6562 17.4375 52.6562H19.3437V54.5625C19.3437 57.716 21.909 60.2812 25.0625 60.2812H55.5625C58.716 60.2812 61.2812 57.716 61.2812 54.5625V24.0625C61.2812 20.909 58.716 18.3437 55.5625 18.3437ZM17.4375 14.5312H47.9375C48.9894 14.5312 49.8437 15.3866 49.8437 16.4375V27.1577L38.2145 40.45L26.3023 30.2401C25.5465 29.5914 24.4184 29.6341 23.7148 30.3396L15.5312 38.5231V16.4375C15.5312 15.3866 16.3856 14.5312 17.4375 14.5312ZM57.4687 54.5625C57.4687 55.6134 56.6144 56.4687 55.5625 56.4687H25.0625C24.0106 56.4687 23.1562 55.6134 23.1562 54.5625V52.6562H47.9375C51.091 52.6562 53.6562 50.091 53.6562 46.9375V22.1562H55.5625C56.6144 22.1562 57.4687 23.0116 57.4687 24.0625V54.5625Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 29.7812C39.6535 29.7812 42.2188 27.216 42.2188 24.0625C42.2188 20.909 39.6535 18.3438 36.5 18.3438C33.3465 18.3438 30.7812 20.909 30.7812 24.0625C30.7812 27.216 33.3465 29.7812 36.5 29.7812Z",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotosIcon);
export default __webpack_public_path__ + "static/media/photosIcon.33731d6d22cb6b1f0e92d0b11373c9db.svg";
export { ForwardRef as ReactComponent };